export const ROUND_TABLE_TRANSLATION_KEYS = {
  toggle: 'jbp-elt-round-table-toggle',
  label: 'jbp-elt-round-table-label',
  tip: 'jbp-elt-round-table-tip',
  addTitle: 'jbp-elt-round-table-add-title',
  review: 'jbp-elt-round-table-review',
  shared: 'jbp-elt-round-table-shared',
  unchanged: 'jbp-elt-round-table-unchanged',
  changeLater: 'jbp-elt-round-table-change-later',
  removeTitle: 'jbp-elt-round-table-remove-title',
  removed: 'jbp-elt-round-table-removed',
  removedLabels: 'jbp-elt-round-table-removed-labels',
  add: 'jbp-elt-round-table-add',
  remove: 'jbp-elt-round-table-remove',
  cancel: 'jbp-elt-round-table-cancel',
  keep: 'jbp-elt-round-table-keep',
  infoTitle: 'jbp-elt-round-table-info-title',
  info: 'jbp-elt-round-table-info',
  error: 'jbp-elt-round-table-error',
} as const
